import * as Blockly from 'blockly/core'
import { EventEmitter } from 'events'
import { commonResource } from '../../i18n/common'

class MessageSystem extends EventEmitter {
  private messages!: string[]
  priority = 90

  constructor() {
    super()
    this.reset()
  }

  add(message: string) {
    message = message.trim().replace(/"/g, '')
    if (!this.messages.includes(message)) this.messages.push(message)
  }

  clear() {
    // This is called when Blockly clears the workspace. However,
    // messages are shared between objects withing the same mission/project,
    // so we only want to clear them when changing missions/projects.
  }

  load(savedMessages: string[]) {
    for (const message of savedMessages) {
      this.add(message)
    }
  }

  remove(message: string) {
    this.messages = this.messages.filter((m) => m !== message)
    this.emit('remove', message)
  }

  reset() {
    this.messages = ['メッセージ']
  }

  save() {
    return this.messages
  }
}

export const messages = new MessageSystem()
Blockly.serialization.registry.register('messages', messages)

export const messageExtensionName = 'message_extension'
export const messageFieldName = 'MESSAGE'
const newMessageKey = '__NEW_MESSAGE__'
const deleteMessageKey = '__DELETE_MESSAGE__'

Blockly.Extensions.register(
  messageExtensionName,
  function (this: Blockly.Block) {
    this.getInput(messageFieldName)?.appendField(
      new Blockly.FieldDropdown(
        function genMenu(this: Blockly.FieldDropdown) {
          const mss = messages
            .save()
            .map((message) => [message, message] as Blockly.MenuOption)
          const len = mss.length
          mss.push([commonResource.to('new_message'), newMessageKey])
          if (len > 1)
            mss.push([
              commonResource.to('delete_message').replace('%1', this.getText()),
              deleteMessageKey,
            ])
          return mss
        },
        function (this: Blockly.FieldDropdown, message) {
          if (message === newMessageKey) {
            const newMessage = prompt(commonResource.to('enter_message'))
            if (newMessage) {
              messages.add(newMessage)
              this.getOptions() // This refreshes the list of valid options.
              this.getSourceBlock()?.setFieldValue(newMessage, 'VAL')
              return newMessage
            }
            return null
          } else if (message === deleteMessageKey) {
            const val = this.getValue()
            if (val) messages.remove(val)
            return this.getValue()
          }
          return message
        },
      ),
      'VAL',
    )
  },
)

export const registerMessageCallbacks = (workspace: Blockly.WorkspaceSvg) => {
  const handleRemove = (message: string) => {
    workspace.getAllBlocks().forEach((block) => {
      const input = block.getInput(messageFieldName)
      if (!input) return
      const field = input.fieldRow[0] as Blockly.FieldDropdown
      if (field && field.getValue() === message) {
        field.setValue(field.getOptions()[0][0])
      }
    })
  }
  messages.on('remove', handleRemove)

  return () => {
    messages.off('remove', handleRemove)
  }
}
